import React from "react";

type Props = {
  src?: string;
  maxWidth?: number;
  maxHeight?: number;
};

const PageLoader = ({ src = "/flexLogoWhite.png" }: Props) => {
  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-b from-primary to-white">
      <div className="after:animate-shine relative flex h-screen w-full overflow-hidden bg-no-repeat before:absolute before:inset-0 before:bg-contain before:bg-no-repeat after:absolute after:left-[-100%] after:top-0 after:h-full after:w-full after:bg-gradient-to-r after:from-transparent after:via-primary after:to-transparent">
        <img src={src} className="object-none" />
      </div>
    </div>
  );
};

export default PageLoader;
